import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">Audience Reviews</h3>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">观众热评</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">看看影迷们怎么说，真实用户反馈，口碑见证品质</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {comments.map((comment) => (
            <article key={comment.id} className="bg-background-50 rounded-lg p-6 border border-secondary-200/60">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden shrink-0 bg-secondary-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="text-sm font-heading font-bold text-foreground-900">{comment.name}</h3>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-secondary-300'}`}
                      ></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center justify-between">
                <div className="flex flex-wrap gap-1.5">
                  {comment.tags.map((tag) => (
                    <span key={tag} className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
                <span className="text-xs text-foreground-400">{comment.date}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}